// Checks if the user can edit or delete a saved route depending if they are a sub-admin or the creator of the route
export function canManageSavedRoute(
  userEmail: string | undefined,
  creatorEmail: string | null | undefined,
  isSubAdmin: boolean,
): boolean {
  if (isSubAdmin) {
    return true;
  }
  return (
    !!userEmail &&
    !!creatorEmail &&
    userEmail.toLowerCase() === creatorEmail.toLowerCase()
  );
}
